import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-mobile-header',
  standalone: true,
  imports: [RouterLink,RouterLinkActive,],
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss'
})
export class MobileHeaderComponent implements OnInit {

  private readonly authService=inject(AuthService);
name: string | null = null;

ngOnInit(): void {
 const auth = localStorage.getItem('auth');
  if (auth) {
   const user = JSON.parse(auth);
    this.name = user.name;
  }
}
logOut() {
 this.authService.logout();
}
}
